// Blindagem contra crash React × tradução automática do navegador.
// DEVE ser o primeiro import (patch global antes do React montar).
// Ver docs/removechild-translate-crash.md
import './lib/translateCrashGuard'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from "react-error-boundary";
import AppRouter from './AppRouter'
import { ErrorFallback } from './ErrorFallback'

import "./main.css"
import "./styles/game-theme.css"

// Configuração do modo de desenvolvimento
const isDev = import.meta.env.DEV
// Log apenas em desenvolvimento
if (isDev) {
  console.log('Running in development mode:', isDev)
}

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <AppRouter />
   </ErrorBoundary>
)
